import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const TbxToolbarActions = ({ children, sx = null }) => {
    return (
        <Box
            sx={[
                {
                    display: 'flex',
                    gap: 2,
                    minWidth: 'fit-content',
                    alignItems: 'center',
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Box>
    )
}

TbxToolbarActions.propTypes = {
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
}

export default TbxToolbarActions
